function createPopInAnim({ framerate, delay, duration, object }) {
    delay = 0;
    // delay = Q3.editMode ? 0 : delay;

    const delayOffset = Math.max(0, delay);
    const stepCount = Math.max(framerate * duration, 3);
    const timeStepSize = 1 / framerate;
    const stepsDecr = Math.max(2, Math.ceil(stepCount * 0.20));
    const stepsIncr = stepCount - stepsDecr;
    const valueStepSizeIncr = 1.2 / stepsIncr;
    const valueStepSizeDecr = 0.2 / (stepsDecr - 1);
    const timeOffset = stepsIncr * timeStepSize;
    const times = [], values = [];
    const animData = Q3.SlideManager.currentSlide.animation[object.uuid];
    const { x: sx, y: sy, z: sz } = animData
        ? Q3.SlideManager.currentSlide.animation[object.uuid].scale
        : object.scale;

    if (delay > 0) {
        const stepCount = framerate * delay;
        const timeStepSize = delay / (stepCount - 1);
        const y = 0;

        for (let i = 0; i < stepCount; i++) {
            const x = timeStepSize * i;
            const scl = Math.max(1e-5, y);

            times.push(x);
            values.push(scl * sx, scl * sy, scl * sz);
        }
    }

    for (let i = 0; i < stepsIncr; i++) {
        const x = timeStepSize * i;
        const y = valueStepSizeIncr * i;
        const scl = Math.max(1e-5, y);

        times.push(x + delayOffset);
        values.push(scl * sx, scl * sy, scl * sz);
    }

    for (let i = 0; i < stepsDecr; i++) {
        const scl = 1.2 - valueStepSizeDecr * i;

        times.push(timeStepSize * i + timeOffset + delayOffset);
        values.push(scl * sx, scl * sy, scl * sz);
    }

    const kfScale = new THREE.VectorKeyframeTrack(".scale", times, values);
    const tracks = [kfScale];
    const clip = new THREE.AnimationClip(THREE.Math.generateUUID(), undefined, tracks);

    return clip;
}

export default createPopInAnim;
export { createPopInAnim };